import React from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/layout.scss';
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { createBrowserHistory } from 'history';
import { routerMiddleware, push } from 'connected-react-router';

import immutableCheckMiddleWare from 'redux-immutable-state-invariant';
import * as serviceWorker from './serviceWorker';
import reducers from './redux/index';
import App from './components/App';
import { CookiesProvider } from 'react-cookie';
import ChatbotButton from './components/Agent/ChatbotButton';

// Imports for google analytics tracking.
import { FACEBOOK_PIXEL_TRACKING_CODE, GOOGLE_ANALYTICS_TRACKING_CODE } from "./settings";
import { removeAuthDetails } from './redux/auth/authAction';
import ReactGA from 'react-ga';
import ReactPixel from "react-facebook-pixel";
import axiosInstance, { setAxiosAuthFailureHandler } from './api/axiosInstance';

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { syncVoiceDebugFlags } from './components/Agent/voice/voiceFeatureTelemetry';

const msalInstance = new PublicClientApplication(msalConfig);

ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_CODE);
ReactPixel.init(FACEBOOK_PIXEL_TRACKING_CODE);

// Read before the router runs: the country redirect (/ → /Sri-Lanka) and any
// later navigation replace the URL, so ?voicedebug=1 is gone by the time the
// voice bar mounts. The flag persists once captured, so the parameter is only
// ever needed on the first load.
syncVoiceDebugFlags();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const dependencies = {
  history: createBrowserHistory(),
};

export const store = createStore(
  reducers(dependencies.history),
  composeEnhancers(
    applyMiddleware(
      routerMiddleware(dependencies.history),
      thunk.withExtraArgument({ history: dependencies.history, axiosInstance }),
      // logger,
      immutableCheckMiddleWare(),
    ),
  ),
);

setAxiosAuthFailureHandler(() => {
  // Clear the dead session quietly. Do not open signup/login on reload —
  // that was popping the auth modal whenever refresh failed.
  store.dispatch(removeAuthDetails());
});

const rootElement = document.getElementById("root");
const renderMethod = rootElement.hasChildNodes() ? ReactDOM.hydrate : ReactDOM.render;

renderMethod(
  <Provider store={store}>
    <CookiesProvider>
      <MsalProvider instance={msalInstance}>
        <ChatbotButton />
        <App dependencies />
      </MsalProvider>
    </CookiesProvider>
  </Provider>,
  rootElement
);

serviceWorker.unregister();
